import InventaireProduitsTable from "@/components/inventaire-produits-table";
import InventaireInfoModal from "@/components/inventaire-info-modal";
import { errorMessage } from '@/utils/inventaire-helpers'

export default {
    name: 'ajout-inventaire',
    components: {
      InventaireProduitsTable,
      InventaireInfoModal,
    },
    props: [],
    data () {
      return {
          loading: false,
          loadingProduits: false,
          inventaire: {
              stock: '',
              perimetre_type: 'stock_complet',
              type_article_id: '',
              article_repartition_ids: [],
          },
          inventaireIdDemande: null,
          quantitesPhysiques: {},
          showInfoModal: false,
          infoModalTitle: 'Information',
          infoModalMessage: '',
      }
    },
    computed: {
      utilisateurId() {
          const auth = this.$store.getters['authInfo'] || {}
          return (auth.user && auth.user.id) || null
      },
      isDemandeInventaire() {
          return this.$route && this.$route.name === 'DemandeInventaire'
      },
      pageTitle() {
          return this.isDemandeInventaire ? 'Demander un inventaire' : 'Lancer un inventaire'
      },
      submitLabel() {
          return this.isDemandeInventaire ? 'Envoyer' : 'Soumettre'
      },
      stocks() {
          return this.$store.getters['stocks'] || []
      },
      isRenseignementDemande() {
          return !!this.inventaireIdDemande
      },
      produitsStock() {
          return this.$store.getters['produitsStock'] || []
      },
      typesArticle() {
          const map = {}
          this.produitsStock.forEach(item => {
              if (item.type_article_id) {
                  map[item.type_article_id] = item.type_article || ('Type #' + item.type_article_id)
              }
          })
          return Object.keys(map).map(id => ({id: parseInt(id), libelle: map[id]}))
      },
      produitsFiltres() {
          if (!this.inventaire.stock) {
              return []
          }
          if (this.inventaire.perimetre_type === 'type_article' && !this.inventaire.type_article_id) {
              return []
          }
          if (this.inventaire.perimetre_type === 'type_article' && this.inventaire.type_article_id) {
              return this.produitsStock.filter(item => parseInt(item.type_article_id) === parseInt(this.inventaire.type_article_id))
          }
          return this.produitsStock
      },
      shouldDisplayInventoryTable() {
          if (!this.inventaire.stock) {
              return false
          }
          if (this.inventaire.perimetre_type === 'selection_manuelle') {
              return true
          }
          if (this.isDemandeInventaire) {
              return false
          }
          if (this.inventaire.perimetre_type === 'stock_complet') {
              return true
          }
          if (this.inventaire.perimetre_type === 'type_article') {
              return !!this.inventaire.type_article_id
          }
          return false
      },
      inventoryTableFields() {
          const fields = []
          if (this.inventaire.perimetre_type === 'selection_manuelle' && !this.isRenseignementDemande) {
              fields.push({ key: 'selection', label: 'Inclure', class: 'algn-center w-80p' })
          }
          fields.push(
              { key: 'article', label: 'Produits' },
              { key: 'quantite', label: 'Qt\u00e9 num\u00e9rique' }
          )
          if (!this.isDemandeInventaire) {
              fields.push(
                  { key: 'quantite_physique', label: 'Qt\u00e9 physique' },
                  { key: 'ecart', label: '\u00c9cart' }
              )
          }
          return fields
      },
      nombreProduitsInclus() {
          if (this.inventaire.perimetre_type === 'selection_manuelle') {
              return this.inventaire.article_repartition_ids.length
          }
          if (this.inventaire.perimetre_type === 'stock_complet') {
              return this.produitsStock.length
          }
          return this.produitsFiltres.length
      },
    },
    mounted () {
        const pContent = this.$el.querySelector('.p-content');
        if (pContent) {
            pContent.classList.remove('is-hidden');
        }

        this.$store.dispatch("getStocks");

        const inventaireId = this.$route && this.$route.query ? this.$route.query.inventaire : null;
        if (inventaireId) {
            this.loadInventaireExistant(inventaireId);
        }
    },
    methods: {
        openInfoModal(message, title = 'Information') {
            this.infoModalMessage = message;
            this.infoModalTitle = title;
            this.showInfoModal = true;
        },
        closeInfoModal() {
            this.showInfoModal = false;
            this.infoModalMessage = '';
        },
        produitIndisponible(item) {
            return !!(item && item.indisponible_inventaire && !this.inventaireIdDemande);
        },
        async loadInventaireExistant(id) {
            try {
                const inventaire = await this.$store.dispatch('getInventaire', id);
                if (!inventaire || inventaire.statut !== 'demande') {
                    this.$router.replace({ path: '/inventaires' });
                    return;
                }
                this.inventaireIdDemande = inventaire.id;
                this.inventaire.stock = inventaire.stock_id;
                this.inventaire.perimetre_type = inventaire.perimetre_type || 'stock_complet';
                this.inventaire.type_article_id = inventaire.perimetre_payload && inventaire.perimetre_payload.type_article_id
                    ? inventaire.perimetre_payload.type_article_id
                    : '';
                await this.loadProduitsStock(true);
                if (this.inventaire.perimetre_type === 'selection_manuelle') {
                    this.inventaire.article_repartition_ids = (inventaire.resultats || [])
                        .map(item => item.article_repartition_id)
                        .filter(id => id);
                }
            } catch (error) {
                this.openInfoModal(errorMessage(error, "Impossible de charger l'inventaire demandé"), 'Erreur');
            }
        },
        async loadProduitsStock(preserveSelection = false) {
            if (!preserveSelection) {
                this.inventaire.article_repartition_ids = [];
                this.inventaire.type_article_id = '';
                this.quantitesPhysiques = {};
            }
            if (!this.inventaire.stock) {
                return;
            }

            this.loadingProduits = true;
            try {
                await this.$store.dispatch('getProduitsStock', this.inventaire.stock);
            } catch (error) {
                this.openInfoModal(errorMessage(error, "Impossible de charger les produits du stock"), 'Erreur');
            } finally {
                this.loadingProduits = false;
            }
        },
        onPerimetreChange() {
            this.inventaire.type_article_id = '';
            this.inventaire.article_repartition_ids = [];
            this.quantitesPhysiques = {};
        },
        onTypeArticleChange() {
            this.inventaire.article_repartition_ids = [];
            this.quantitesPhysiques = {};
        },
        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                this.scrollToFirstInvalidTopField();
                return;
            }

            if (this.inventaire.perimetre_type === 'selection_manuelle' && this.inventaire.article_repartition_ids.length === 0) {
                this.openInfoModal('S\u00e9lectionnez au moins un produit pour un inventaire partiel manuel.');
                return;
            }

            const lignesIncluses = this.lignesIncluses();
            if (lignesIncluses.length === 0) {
                this.openInfoModal('Aucun produit s\u00e9lectionn\u00e9 pour cet inventaire.');
                return;
            }
            if (!this.isDemandeInventaire) {
                const ligneSansQuantite = lignesIncluses.find(item => this.quantitesPhysiques[item.article_repartition_id] === undefined || this.quantitesPhysiques[item.article_repartition_id] === '' || this.quantitesPhysiques[item.article_repartition_id] === null);
                if (ligneSansQuantite) {
                    this.openInfoModal('Renseignez toutes les quantit\u00e9s physiques avant de soumettre l\u2019inventaire.');
                    return;
                }
            }

            this.loading = true;
            try {
                const payload = {
                    stock: this.inventaire.stock,
                    perimetre_type: this.inventaire.perimetre_type,
                    type_article_id: this.inventaire.type_article_id || null,
                    article_repartition_ids: this.inventaire.perimetre_type === 'selection_manuelle'
                        ? this.inventaire.article_repartition_ids
                        : [],
                    utilisateur_id: this.utilisateurId,
                };

                if (this.inventaireIdDemande) {
                    await this.$store.dispatch('updateInventaireResultats', {
                        id: this.inventaireIdDemande,
                        resultats: lignesIncluses.map(item => ({
                            article_repartition_id: item.article_repartition_id,
                            quantite_physique: this.quantitesPhysiques[item.article_repartition_id],
                        })),
                    });
                    await this.$store.dispatch('soumettreInventaire', { id: this.inventaireIdDemande, utilisateur_id: this.utilisateurId });
                } else if (this.isDemandeInventaire) {
                    await this.$store.dispatch("demanderInventaire", payload);
                } else {
                    payload.resultats = lignesIncluses.map(item => ({
                        article_repartition_id: item.article_repartition_id,
                        quantite_physique: this.quantitesPhysiques[item.article_repartition_id],
                    }));
                    await this.$store.dispatch("saveInventaire", payload);
                }
                this.$router.push({ path: `/inventaires` });
            } catch (error) {
                this.openInfoModal(errorMessage(error, "Impossible de cr\u00e9er l'inventaire"), 'Erreur');
            } finally {
                this.loading = false;
            }
        },
        onCancelClick() {
            this.$router.push({ path: `/inventaires` });
        },
        lignesIncluses() {
            const produitsDisponibles = this.produitsFiltres.filter(item => !this.produitIndisponible(item));
            if (this.inventaire.perimetre_type === 'selection_manuelle') {
                return produitsDisponibles.filter(item => this.inventaire.article_repartition_ids.includes(item.article_repartition_id));
            }
            return produitsDisponibles;
        },
        scrollToFirstInvalidTopField() {
            const invalidFields = [];
            if (!this.inventaire.stock) {
                invalidFields.push('stock');
            }
            if (this.inventaire.perimetre_type === 'type_article' && !this.inventaire.type_article_id) {
                invalidFields.push('type_article_id');
            }

            if (!invalidFields.length) {
                return;
            }

            this.$nextTick(() => {
                const field = this.$el.querySelector(`[data-inventory-field="${invalidFields[0]}"]`);
                if (!field) {
                    return;
                }

                field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                const input = field.querySelector('input, select, textarea');
                if (input) {
                    input.focus({ preventScroll: true });
                }
            });
        },
    }
}
